import { Reducer } from 'redux';
import { PO_CHANGE_REQUEST } from './actions';
import { IPoChangeRequestState } from '../../interfaces/change-request-interfaces';

const initialPoChangeRequestState: IPoChangeRequestState = {
  error: '',
  redirect: false,
  loading: false
};

export const poChangeRequestReducer: Reducer<IPoChangeRequestState> = (state: IPoChangeRequestState = initialPoChangeRequestState, action) => {
  switch (action.type) {
    case PO_CHANGE_REQUEST.REQUEST:
      return { ...state, loading: true, redirect: false, error: '' };

    case PO_CHANGE_REQUEST.SUCCESS:
      return { ...state, loading: false, redirect: true, error: '' };

    case PO_CHANGE_REQUEST.FAILURE:
      return { ...state, loading: false, redirect: false, error: action.payload.message };

    case PO_CHANGE_REQUEST.REDIRECTED:
      return { ...state, loading: false, redirect: false, error: '' };

    default:
      return state;
  }
};
